module.exports = __webpack_public_path__ + "static/media/na.badd5d84.svg";